<template>
  <div class="space-y-1">
    <button
      v-for="option in sortOptions"
      :key="option.value"
      type="button"
      class="flex w-full items-center justify-between rounded-lg px-4 py-3.5 text-left text-sm transition-colors"
      :class="selected === option.value
        ? 'bg-primary-50 dark:bg-primary-950/40 font-medium text-primary-700'
        : 'text-toned hover:bg-muted'"
      @click="select(option.value)"
    >
      <span>{{ option.label }}</span>
      <UIcon
        v-if="selected === option.value"
        name="i-heroicons-check"
        class="size-5 shrink-0 text-primary-600"
      />
    </button>
  </div>
</template>

<script setup lang="ts">
import type { ProductFilterState } from '~/types'
import {
  PRODUCT_SORT_OPTIONS,
  sortStateFromUiValue,
  toUiSortValue,
  visibleProductSortOptions,
} from '~/utils/productFilters'

const props = defineProps<{
  filters: ProductFilterState
}>()

const emit = defineEmits<{
  update: [filters: ProductFilterState]
}>()

const { reviewsEnabled, recommendedSortEnabled } = useSiteSettings()

const sortOptions = computed(() => visibleProductSortOptions({
  reviewsEnabled: reviewsEnabled.value,
  recommendedEnabled: recommendedSortEnabled.value,
}))

const selected = computed(() => toUiSortValue(props.filters.sortBy, props.filters.sortOrder))

function select(value: typeof PRODUCT_SORT_OPTIONS[number]['value']) {
  emit('update', { ...props.filters, ...sortStateFromUiValue(value), page: 1 })
}
</script>
